/**
 * Calendar "today" in the user's local timezone as YYYY-MM-DD.
 * Prefer this over Date midnight comparisons for date-only fields (avoids UTC skew).
 */
export function todayIsoDateLocal() {
  const t = new Date();
  const y = t.getFullYear();
  const m = String(t.getMonth() + 1).padStart(2, '0');
  const d = String(t.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

/** True when `v` is YYYY-MM-DD on or before local today (valid start date). */
export function isSignupStartIsoDateAllowed(v) {
  if (!v || !/^\d{4}-\d{2}-\d{2}$/.test(String(v))) return true;
  return String(v) <= todayIsoDateLocal();
}

/** True when `v` is YYYY-MM-DD on or after local today (valid end / expiry date). */
export function isSignupEndIsoDateAllowed(v) {
  if (!v || !/^\d{4}-\d{2}-\d{2}$/.test(String(v))) return true;
  return String(v) >= todayIsoDateLocal();
}

/**
 * Coerce common typed/pasted date strings to YYYY-MM-DD for native date inputs + Yup.
 * - Already ISO: unchanged
 * - DD/MM/YYYY vs MM/DD/YYYY: if one segment is > 12, that side is treated as day or month accordingly;
 *   otherwise day-first (typical outside US) is assumed.
 */
export function normalizeWizardDateInput(value) {
  if (value == null) return '';
  const s = String(value).trim();
  if (!s) return '';
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const m = s.match(/^(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})$/);
  if (!m) return s;
  const p1 = parseInt(m[1], 10);
  const p2 = parseInt(m[2], 10);
  const y = m[3];
  let day;
  let month;
  if (p1 > 12) {
    day = p1;
    month = p2;
  } else if (p2 > 12) {
    month = p1;
    day = p2;
  } else {
    day = p1;
    month = p2;
  }
  if (month < 1 || month > 12 || day < 1 || day > 31) return s;
  const iso = `${y}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  const dt = new Date(`${iso}T12:00:00`);
  if (Number.isNaN(dt.getTime())) return s;
  if (dt.getMonth() + 1 !== month || dt.getDate() !== day) return s;
  return iso;
}
